import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import router from './router'
import store from './store'
import i18n from './extensions/i18n'
import { loadPlugins } from './awesome'
import loadPlugins2 from './plugins'
import loadDirectives from './directives/index'

import { Vue3Mq } from 'vue3-mq'

// https://tailwind-elements.com/quick-start/
// import 'tw-elements'

const { FontAwesomeIcon } = loadPlugins()

const init = () => loadPlugins2()

init().then(() => {
    const app = createApp(App)

    loadDirectives(app)
      .then(app => {
        app
          .use(router)
          .use(store)
          .use(i18n)
          .use(Vue3Mq)
          .component('font-awesome-icon', FontAwesomeIcon)
          .mount("#app")
      })
  })
